export function isPhoto(filename) {
  switch (filename.toLowerCase()) {
    case "jpg":
    case "gif":
    case "jpeg":
    case "bmp":
    case "png":
      //etc
      return true;
  }
  return false;
}

export function isResume(filename) {
  switch (filename.toLowerCase()) {
    case "pdf":
    case "doc":
    case "docx":
    case "txt":
      //etc
      return true;
  }
  return false;
}

export function isPdf(extension) {
  return extension == "pdf";
}
export function isExcel(extension) {
  switch (extension.toLowerCase()) {
    case "xls":
    case "xlsx":
      //etc
      return true;
  }
  return false;
}
